import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import NewsletterSignup from "@/components/NewsletterSignup";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_66258ad9-e000-456c-bbb1-9b3da697cdba/artifacts/pl46n86d_New%20SCAH%20Logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Sickle Cell Association" 
                className="h-16 w-auto"
              />
              <div>
                <p className="font-serif font-semibold text-white text-lg leading-tight">Sickle Cell</p>
                <p className="text-xs text-red-500 tracking-wider uppercase font-medium">Association</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Advocating for patients and families affected by sickle cell disease in the Greater Houston area and across Texas.
            </p>
            <p className="!font-medium !text-xs text-amber-400">A Not-for-Profit Organization

            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-amber-400 text-lg font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
              { name: "About Us", path: "/about" },
              { name: "Legislative Victories", path: "/legislative-victories" },
              { name: "Events", path: "/events" },
              { name: "Members", path: "/members" },
              { name: "Gallery", path: "/gallery" },
              { name: "Contact", path: "/contact" }].
              map((link) =>
              <li key={link.path}>
                  <Link
                  to={link.path}
                  className="text-slate-400 hover:text-white text-sm footer-link transition-colors">

                    {link.name}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-serif text-amber-400 text-lg font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-teal-500 flex-shrink-0 mt-0.5" />
                <span className="!text-sm text-slate-400">
                  4014 Market Street 
Houston, Texas 77020
                  <br />
                  Greater Houston Area
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-teal-500 flex-shrink-0" />
                <a href="tel:+17135555555" className="hover:text-white footer-link !text-sm text-slate-400">(832) 252-9293

                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-teal-500 flex-shrink-0" />
                <a href="mailto:info@sicklecellhouston.org" className="hover:text-white footer-link !text-sm text-slate-400">care@sicklecellhouston.org

                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter & Social */}
          <div>
            <h3 className="font-serif text-amber-400 text-lg font-semibold mb-6">Stay Connected</h3>
            <p className="text-slate-400 text-sm mb-4">Subscribe to our newsletter for updates on advocacy and events.</p>
            <NewsletterSignup variant="dark" />
            
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Sickle Cell Association. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-slate-500 hover:text-white text-sm footer-link">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-white text-sm footer-link">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>);};

export default Footer;